import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LEGEND_PUBLIC_COLOR, LEGEND_ROADS_COLOR } from '../../features/transport-layers/constants';
import type { LegendEntry } from '@ooh/ui/components/map-layer-legend';

export function useTransportLegendEntries(
  isPublicEnabled: boolean,
  isRoadsEnabled: boolean,
): LegendEntry[] {
  const { t } = useTranslation('map');
  return React.useMemo((): LegendEntry[] => {
    const entries: LegendEntry[] = [];
    if (isPublicEnabled) {
      entries.push({
        id: 'transport-public',
        label: t('transportLayers.legend.publicTransport'),
        color: LEGEND_PUBLIC_COLOR,
        variant: 'line',
        pattern: 'dashed',
        borderColor: '#e2e8f0',
        bgColor: 'transparent',
        textColor: undefined,
      });
    }
    if (isRoadsEnabled) {
      entries.push({
        id: 'transport-roads',
        label: t('transportLayers.legend.roads'),
        color: LEGEND_ROADS_COLOR,
        variant: 'line',
        pattern: 'solid',
        borderColor: '#e2e8f0',
        bgColor: 'transparent',
        textColor: undefined,
      });
    }
    return entries;
  }, [isPublicEnabled, isRoadsEnabled, t]);
}
